import classNames from 'classnames';

import styles from './stepper.module.css';

export const StepperIndicator = (props: {
  isActive: boolean;
  isComplete: boolean;
}) => {
  return (
    <div
      className={classNames(styles.stepperIndicator, {
        [styles.stepperIndicatorActive ?? '']: props.isActive,
        [styles.stepperIndicatorComplete ?? '']: props.isComplete,
      })}
    >
      <div className={styles.stepperIndicatorCenter}>
        <svg
          className={classNames(styles.stepperCheck, {
            [styles.stepperCheckComplete ?? '']: props.isComplete,
          })}
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 7L1.5 3L0 4.5L5.5 10L14 1.5L12.5 0L5.5 7Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );
};
